import axios from "../axios-auth";

export const manufacturingCostService = {
    getManufacturingCostList,
    getManufacturingCostDetail,
    saveManufacturingCost,
    getManufacturingCostByStatus
}

function getManufacturingCostList(searchParams, page, size, sortBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortBy
    }

    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return axios.get("/auth/manufacturing-costs", { params });
}

function getManufacturingCostDetail(id) {
    return axios.get("/auth/manufacturing-cost/" + id);
}

function saveManufacturingCost(manufacturingCost) {
    if (!manufacturingCost.id) {
        // new manufacturing cost
        return axios.post("/auth/manufacturing-cost", manufacturingCost);
    } else {
        // edit
        return axios.put("/auth/manufacturing-cost", manufacturingCost);
    }
}

function getManufacturingCostByStatus(status) {
    return axios.get("/auth/manufacturing-costs-by-status/" + status);
}
